import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from '../../../../../Components/CustomInput';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        width: "500px",
        padding: theme.spacing(3),
    },

    dialog_title: {
        marginLeft: '1.5rem',
        "& h6": {
            fontWeight: "700"
        }
    },
    btnCss: {
        fontSize: "14px",
        fontFamily: "Open Sans",
        lineHeight: "16px",
        height: "35px",
    }

}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const MasterHeaderModal = (props) => {
    const {
        isOpen,
        onClose,
        currentSelection,
        headerInputValue,
        setHeaderInputValue,
        headerType,
        stepperData,
    } = props;
    const classes = useStyles();
    const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
    useEffect(() => {
        if (stepperData) {
            setHeaderInputValue(stepperData);
        }
    }, [stepperData])

    const handleInputValue = (value, name) => {
        setHeaderInputValue(value);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        var formData = new FormData()
        formData.append('master_template_id', currentSelection?.id);
        formData.append('header_name', headerInputValue);
        formData.append('type', headerType);

        DataService.createData(formData, "change_header_name").then((res) => {
            if (res?.success) {
                props?.setFetchApiFlag(true);
                onClose();
            }
        }
        ).catch((error) => {
            setSubmitClickFlag(true)
        })
    }

    return (
        <>
            <Dialog maxWidth={"sm"} fullWidth={true} open={isOpen} onClose={onClose}
                aria-labelledby="base-station-manage">
                <DialogTitle id="customized-dialog-title">
                    Header template
                </DialogTitle>
                <Divider />
                <DialogContent style={{ margin: '0px auto' }}>
                    <div className={classes.formWrapper}>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <Grid container alignItems={"center"}>
                                    <Grid item xs={3}>
                                        <Typography variant="h2">Name</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <CustomInput error={submitClickFlag && headerInputValue == "" ? true : false}
                                            helperText={submitClickFlag && headerInputValue == "" ? "Please enter the header name.!" : ""}
                                            variant="outlined" id="header_name"
                                            name={'header_name'}
                                            parentcall={(value, name) => {
                                                handleInputValue(value, name)
                                            }}
                                            value={headerInputValue}
                                            InputLabelProps={{ shrink: true }} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems={"center"} justify={"flex-end"}
                                    style={{ marginTop: 20 }}>
                                    <Grid item xs={2} style={{ marginRight: '1rem' }}>
                                        <Button disableElevation type="button" style={{ textTransform: 'capitalize' }}
                                            onClick={onClose}
                                            variant={"contained"}
                                            className={classes.btnCss}
                                        >Cancel</Button>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Button disableElevation type="submit" style={{ textTransform: 'capitalize' }}
                                            variant={"contained"}
                                            className={classes.btnCss}
                                            color="secondary">
                                            {"Create"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </form>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default MasterHeaderModal;
